<template>
  <div v-safe-html="htmlContent" class="stb-markdown"></div>
</template>

<script>
import { marked } from 'marked';

export default {
  props: {
    source: {
      type: String,
      required: true,
      default: ''
    }
  },

  emits: ['markdown-error'],

  data() {
    return {
      htmlContent: ''
    };
  },
  watch: {
    source: {
      async handler(newValue) {
        try {
          marked.use({ breaks: true });
          this.htmlContent = await marked.parse(newValue);
        } catch (error) {
          this.htmlContent = '';
          console.error('Error parsing markdown:', error);
          this.$emit('markdown-error');
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.stb-markdown :deep(ul),
.stb-markdown :deep(ol) {
  padding-left: 24px !important;
}

.stb-markdown :deep(p) {
  margin-bottom: 0 !important;
}
.stb-markdown {
  white-space: normal !important;
}
</style>
